import styled, { css } from 'styled-components';
import {
    Button,
    mediaMixin,
    token,
} from '@zillow/constellation';
import InteractiveCard from 'app/shared/components/InteractiveCard';

import MESSAGE_MODULE_TYPES from '../../MESSAGE_MODULE_TYPES';

export const StyledCard = styled(InteractiveCard)`
    box-shadow: none;

    ${(props) => {
        if (props.type === MESSAGE_MODULE_TYPES.WARNING) {
            return css`
                background-color: ${token('colors.backgroundRed')}
            `;
        }

        return css`
            background-color: ${token('colors.backgroundGreen')}
        `;
    }}
`;

export const StyledButton = styled(Button)`
    ${mediaMixin('md', css`
        width: 60%;
    `)}
`;
